export default [
  {
    path: '/lottery-balance-report',
    name: 'lottery-balance-report',
    component: () => import('@/views/lotteryBalanceReport/List.vue'),
    meta: {
      pageTitle: 'breadcrumb.lotteryBalanceReport',
      resource: 'balance-report-lottery',
      action: 'read',
      breadcrumb: [
        {
          text: 'breadcrumb.listLotteryBalanceReport',
          active: true,
        },
      ],
    },
  },
]
